/* Behind the scenes: scroll is the film. The frames swap like stop-motion (wool, ball, shape, friend), the felting
   needle pokes whenever you're scrolling, and the poke and frame counters run with you. */
(function () {
  'use strict';
  var WH = window.WH;
  if (!WH) return;
  WH.register('made', function (sec) {
    var frames = Array.prototype.slice.call(sec.querySelectorAll('[data-frame]'));
    var steps = Array.prototype.slice.call(sec.querySelectorAll('[data-step]'));
    var needle = sec.querySelector('[data-made-needle]'), pokes = sec.querySelector('[data-pokes]'), film = sec.querySelector('[data-film]');
    var cur = -1, p = 0, visible = false, poke = 0;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(sec);
    else visible = true;
    /* where the section sits on the page, measured once (and on resize), so scrolling never has to ask for layout */
    var top = 0, span = 1;
    function measure() { var r = sec.getBoundingClientRect(); top = r.top + window.scrollY; span = Math.max(1, r.height - window.innerHeight); }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(document.body);
    function progress() { return WH.clamp((window.scrollY - top) / span, 0, 1); }
    function show(i) {
      if (i === cur) return;
      var prev = cur;
      cur = i;
      frames.forEach(function (f, k) { f.classList.toggle('is-on', k === i); });
      var si = Math.min(steps.length - 1, Math.floor(i * steps.length / frames.length));
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k === si); });
      if (prev >= 0 && WH.anim) {
        WH.sound.play('pop');
        gsap.fromTo(frames[i], { scaleX: 1.16, scaleY: 0.84 }, { scaleX: 1, scaleY: 1, duration: 0.34, ease: WH.sm('elastic.out(1.2,.4)', 0.34), transformOrigin: '50% 100%' });
      }
    }
    var lastPokes = '', lastFilm = '', queued = false;
    function update() {
      queued = false;
      p = progress();
      show(Math.min(frames.length - 1, Math.floor(p * frames.length * 0.999)));
      var pk = Math.round(p * 2400).toLocaleString('en-US'), fm = String(1 + Math.floor(p * 287)).padStart(4, '0');
      if (pk !== lastPokes) { pokes.textContent = pk; lastPokes = pk; }
      if (fm !== lastFilm) { film.textContent = fm; lastFilm = fm; }
    }
    /* one update per drawn frame, however many scroll events arrive */
    window.addEventListener('scroll', function () { if (visible && !queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    if (WH.reduce) return;
    WH.onFrame(function () {
      if (!visible) return;
      var moving = Math.abs(WH.scroll.v) > 0.6;
      poke = moving ? (poke + 1) % 2 : 0;
      needle.style.transform = 'translateY(' + (poke ? 9 : 0) + '%)';
    });
  });
})();
